import React from "react";
import "../../../Styles/components/form-controls.scss";

export default function CurrencyRadioGroup({
  className = "",
  error = "",
  label = "",
  name = "currency",
  onChange,
  options = [],
  value,
}) {
  return (
    <div className={["form-field", className].filter(Boolean).join(" ")}>
      {label ? <label className="form-field__label">{label}</label> : null}
      <div className="currency-radio-group">
        {options.map((option) => {
          const isActive = String(value) === String(option.value);
          return (
            <label
              key={option.value}
              className={`currency-radio-group__option ${isActive ? "is-active" : ""}`}
            >
              <input
                type="radio"
                name={name}
                checked={isActive}
                value={option.value}
                onChange={() => onChange?.(option.value)}
              />
              <span>{option.label}</span>
            </label>
          );
        })}
      </div>
      {error ? <div className="form-field__error">{error}</div> : null}
    </div>
  );
}
